import { useRef, useImperativeHandle, forwardRef, useState } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';

export type RecaptchaFieldHandle = {
  token: string | null;
  reset: () => void;
  passed: boolean;
};

const RecaptchaField = forwardRef<RecaptchaFieldHandle>((_, ref) => {
  const recaptchaRef = useRef<ReCAPTCHA | null>(null);
  const [token, setToken] = useState<string | null>(null);

  useImperativeHandle(ref, () => ({
    token,
    passed: !!token,
    reset: () => {
      recaptchaRef.current?.reset();
      setToken(null);
    },
  }));

  const sitekey = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

  return (
    <div className="mb-4">
      <ReCAPTCHA
        ref={recaptchaRef}
        sitekey={sitekey}
        onChange={(token) => setToken(token)}
      />
    </div>
  );
});

export default RecaptchaField;
